<template>
  <MenuApp  v-if="isMenuShow" />
  <AlertMe />
  <router-view/>
</template>

<script>
import AlertMe from './components/AlertMe.vue'
import MenuApp from './components/MenuApp.vue';
export default {
  components: {
    AlertMe,
    MenuApp
  },
  data() {
    return {
      
    };
  },
  computed: {
    isMenuShow(){
      return this.$route.path !== "/login"
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.active {
  font-weight: bold;
}

.ml-auto {
  margin-left: auto !important;
}

.mr-auto {
  margin-right: auto !important;
}

.navbar-nav.ml-auto {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flag-icon {
  width: 35px;
  height: auto;
  margin-right: 8px;
  vertical-align: middle;
}

.logo {
  width: 25%;
}

.nav-border-bottom {
  border-bottom: 3px solid #86b7fe !important;
}

html[lang="ar"] {
    direction: rtl;
    text-align: right;
  }

</style>
